//@flow
import React, { Component, type Element } from 'react';
import { connect } from 'react-redux';
import {
  type TooltipProps,
  type Currency,
  type Currencies
} from '../../utilities/types';
import { SpacerTd } from '../ModelListStyles';
import TableHeader from './TableHeader';
import {
  CustomModelListDiv,
  CustomModelListTable,
  ToggleTotal,
  FeeNotificationDiv
} from './StatisticsStyles';
import { Device, Desktop, Mobile } from '../Responsive';
import TableRow from './TableRow';
import { getPartnerCurrency, getCurrencies } from '../../utilities/selectors';
import { dig } from '../../utilities/misc';

export type TableHeaderOptionProps = {
  desktop: Array<{ lg?: string, sm?: string, right?: boolean }>,
  device: {
    row1: Array<{
      lg?: string,
      sm?: string,
      right?: boolean,
      tooltip?: boolean
    }>,
    row2: Array<{ lg?: string, sm?: string, right?: boolean }>
  }
};

export type TableRowOptionProps = {
  desktop: {
    breakdown: {
      data: Array<{}>,
      columns: Array<{
        value: string,
        showOnce?: boolean,
        right: boolean,
        bold?: boolean
      }>
    },
    total: {
      toggled: Array<{ value: string, right: boolean, bold?: boolean }>,
      untoggled: Array<{ value: string, right: boolean, bold?: boolean }>
    }
  },
  device: {
    row1: Array<{ value: String, bold: boolean, right?: boolean }>,
    row2: {
      breakdown: {
        data: Array<{}>,
        columns: Array<{
          value: string
        }>
      },
      total: Array<{ value: string | Element<any> }>
    }
  }
};

type Props = {
  partnerCurrency: Currency,
  currencies: Currencies,
  ...$Exact<TooltipProps>,
  storageTotalOptions: {
    handler: Function,
    slice: string,
    value: string
  },
  storageDetailOptions: {
    handler: Function,
    slice: string,
    value: string
  },
  tableRowOptions: TableRowOptionProps,
  tableHeaderOptions: TableHeaderOptionProps
};

class Statistics extends Component<Props> {
  handleToggleTotal = () => {
    this.props.storageTotalOptions.handler();
    const newValue = String(!this.props.storageTotalOptions.slice);
    localStorage.setItem(this.props.storageTotalOptions.value, newValue);
  };

  handleToggleDetail = () => {
    this.props.storageDetailOptions.handler();
    const newValue = String(!this.props.storageDetailOptions.slice);
    localStorage.setItem(this.props.storageDetailOptions.value, newValue);
  };

  render() {
    const data = dig(
      this.props.tableRowOptions,
      'desktop',
      'breakdown',
      'data'
    );

    const hasProcessingSums = (data || []).length > 0;
    return (
      <CustomModelListDiv toggleState={this.props.storageTotalOptions.slice}>
        <ToggleTotal
          iconName={
            this.props.storageTotalOptions.slice
              ? 'minusCircleThick'
              : 'plusCircleThick'
          }
          text="Totals"
          activeText="Hide"
          inActiveText="Show"
          setToggleState={this.handleToggleTotal}
          toggleState={this.props.storageTotalOptions.slice}
        />
        <CustomModelListTable>
          <thead>
            <tr>
              <SpacerTd />
              <Desktop>
                <TableHeader
                  desktop
                  activeTooltip={this.props.activeTooltip}
                  showTooltip={this.props.showTooltip}
                  tableHeaderOptions={this.props.tableHeaderOptions}
                />
              </Desktop>
              {hasProcessingSums && (
                <Device>
                  <TableHeader
                    deviceRow1
                    activeTooltip={this.props.activeTooltip}
                    showTooltip={this.props.showTooltip}
                    tableHeaderOptions={this.props.tableHeaderOptions}
                  />
                </Device>
              )}
              <SpacerTd />
            </tr>
          </thead>
          <tbody>
            <Desktop>
              <TableRow
                desktop
                tableRowOptions={this.props.tableRowOptions}
                toggleState={this.props.storageDetailOptions.slice}
                setToggleState={this.handleToggleDetail}
                partnerCurrency={this.props.partnerCurrency}
                currencies={this.props.currencies}
                hasProcessingSums={hasProcessingSums}
              />
            </Desktop>
            <Device>
              <TableRow
                deviceRow1
                tableRowOptions={this.props.tableRowOptions}
                partnerCurrency={this.props.partnerCurrency}
                hasProcessingSums={hasProcessingSums}
              />
            </Device>
          </tbody>
        </CustomModelListTable>
        <Device>
          <CustomModelListTable>
            <thead>
              <tr>
                <SpacerTd />
                {hasProcessingSums && (
                  <TableHeader
                    deviceRow2
                    tableHeaderOptions={this.props.tableHeaderOptions}
                  />
                )}
                <SpacerTd />
              </tr>
            </thead>
            <tbody>
              <TableRow
                deviceRow2
                toggleState={this.props.storageDetailOptions.slice}
                setToggleState={this.handleToggleDetail}
                currencies={this.props.currencies}
                partnerCurrency={this.props.partnerCurrency}
                tableRowOptions={this.props.tableRowOptions}
                hasProcessingSums={hasProcessingSums}
              />
            </tbody>
          </CustomModelListTable>
        </Device>
        {this.props.storageTotalOptions.slice && hasProcessingSums && (
          <Mobile>
            <FeeNotificationDiv>
              <p>
                To view total fees, please log in to your account on a computer
              </p>
            </FeeNotificationDiv>
          </Mobile>
        )}
      </CustomModelListDiv>
    );
  }
}

const mapStateToProps = state => ({
  partnerCurrency: getPartnerCurrency(state),
  currencies: getCurrencies(state)
});

export default connect(mapStateToProps)(Statistics);
